import {
  PUT_OPERATORS_CATALOG,
  PUT_OPERATORS_CATALOG_SUCCESS,
  PUT_OPERATORS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const putOperatorsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case PUT_OPERATORS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case PUT_OPERATORS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case PUT_OPERATORS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
